export default __webpack_public_path__ + "static/media/AF77B1E7-00.98834052.png";